import { render, staticRenderFns } from "./childInfo.vue?vue&type=template&id=46bc45eb&scoped=true&"
import script from "./childInfo.vue?vue&type=script&lang=js&"
export * from "./childInfo.vue?vue&type=script&lang=js&"
import style0 from "./childInfo.vue?vue&type=style&index=0&id=46bc45eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc45eb",
  null
  
)

export default component.exports